import { render, staticRenderFns } from "./SellersList.vue?vue&type=template&id=2d345541&scoped=true&"
import script from "./SellersList.vue?vue&type=script&lang=js&"
export * from "./SellersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d345541",
  null
  
)

export default component.exports